var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 117,
    viewBox: "0 0 91 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2778 58.5H83.4167C85.5232 58.5 87.3137 59.2109 88.7882 60.6328C90.2627 62.0547 91 63.7812 91 65.8125V109.688C91 111.719 90.2627 113.445 88.7882 114.867C87.3137 116.289 85.5232 117 83.4167 117H7.58333C5.47685 117 3.68634 116.289 2.21181 114.867C0.737269 113.445 0 111.719 0 109.688V65.8125C0 63.7812 0.737269 62.0547 2.21181 60.6328C3.68634 59.2109 5.47685 58.5 7.58333 58.5H10.1111V34.125C10.1111 24.7305 13.5736 16.6943 20.4987 10.0166C27.4238 3.33887 35.7575 0 45.5 0C55.2425 0 63.5762 3.33887 70.5013 10.0166C77.4264 16.6943 80.8889 24.7305 80.8889 34.125C80.8889 35.4453 80.3886 36.5879 79.388 37.5527C78.3874 38.5176 77.2025 39 75.8333 39H70.7778C69.4086 39 68.2237 38.5176 67.2231 37.5527C66.2225 36.5879 65.7222 35.4453 65.7222 34.125C65.7222 28.7422 63.7474 24.1465 59.7977 20.3379C55.8481 16.5293 51.0822 14.625 45.5 14.625C39.9178 14.625 35.1519 16.5293 31.2023 20.3379C27.2526 24.1465 25.2778 28.7422 25.2778 34.125V58.5Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.37bce24d198bcfa14e1f61788ee23499.svg";
export { ForwardRef as ReactComponent };